module.exports = __webpack_public_path__ + "img/image-post.f63e2bfb.png";